import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";

import Drawer from "core/Drawer";
import Heading from "core/Heading";
import CloseIcon from "core/ReusableIcons/Close";
import Icon from "core/ReusableIcons/Icon";
import LicenseButton from "core/LicenseButton";
import {
    Title,
    IconName,
    Buttons,
    ContinueButton,
    CancelButton
} from "./styles";

import {
    PRO_ANNUAL_DOWNLOAD,
    PRO_MONTHLY_DOWNLOAD,
    PRO_SINGLE_DOWNLOAD,
    FREE_DOWNLOAD,
    getLicenseSchema
} from "icons/helpers";

const IconDetailDrawer = ({
    icon,
    onClose,
    onSubmit,
    show,
    hasEditedIcon = false,
    setSubscriptionSelected
}) => {
    const [selected, setSelected] = useState(PRO_ANNUAL_DOWNLOAD);

    const onSubmitClick = useCallback(() => {
        onSubmit(selected);
    }, [selected, onSubmit]);

    const licenseProps = {
        icon,
        hasEditedIcon,
        selected,
        setSelected,
        setSubscriptionSelected
    };
    const licenseSchemas = [
        [
            getLicenseSchema(PRO_ANNUAL_DOWNLOAD, licenseProps),
            getLicenseSchema(PRO_MONTHLY_DOWNLOAD, licenseProps)
        ],
        [getLicenseSchema(PRO_SINGLE_DOWNLOAD, licenseProps)],
        [getLicenseSchema(FREE_DOWNLOAD, licenseProps)]
    ];

    return (
        <Drawer
            show={show}
            onClose={onClose}
            closeLabel="Cancel license selection"
        >
            <Title>
                <Heading type="h1" size="sm">
                    Get This Icon
                </Heading>
                <button aria-label="Close" onClick={onClose}>
                    <CloseIcon />
                </button>
            </Title>
            <IconName>
                <Icon />
                <p>{icon.title}</p>
            </IconName>
            {licenseSchemas.map((schemas, i) => (
                <LicenseButton key={i} type="icon" schemas={schemas} />
            ))}
            <Buttons>
                <ContinueButton onClick={onSubmitClick}>
                    Continue
                </ContinueButton>
                <CancelButton onClick={onClose}>Cancel</CancelButton>
            </Buttons>
        </Drawer>
    );
};

IconDetailDrawer.propTypes = {
    icon: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    show: PropTypes.bool,
    hasEditedIcon: PropTypes.bool,
    setSubscriptionSelected: PropTypes.func.isRequired
};

export default IconDetailDrawer;
